<div class="hierarchy-mismatch-view">
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font">
      <div class="uitk_new_header">
        <div class="uitk-l-grid__col--12 stk-container-tabl-header">
          @if (heirarchyData && heirarchyData.length==0) {
          <div class="headerText">
            <p class="highlightText">There is no hierarchy mismatches</p>
          </div>
          } @if (heirarchyData && heirarchyData.length>0) {
          <div class="topCardFlex">
            <div class="flex-topcard-container">
              <div class="topcard-titles-dropdown">Select Hierarchy Segments</div>
              <mat-form-field class="formContainer">
                <div class="selectedTextDropdown d-flex flex-row">
                  <div>{{ selectedText }}</div>
                  <mat-icon class="dropDownArrow">arrow_drop_down</mat-icon>
                </div>
                <mat-select
                  [formControl]="segment"
                  multiple
                  (selectionChange)="onSelectionChange($event)"
                  placeholder="Select Segment"
                >
                  @for (seg of segmentList; track seg) {
                  <mat-option class="dropdownOptionsColor" [value]="seg">{{ seg }}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
            <div class="flex-topcard-container">
              <div class="topcard-titles">Hierarchy Mismatches</div>
              <div class="pill">{{ hierarchyMismatches }}</div>
            </div>
            <div class="flex-topcard-container">
              <div class="topcard-titles">UCMG ID's</div>
              <div class="pill">{{ ucmgIds }}</div>
            </div>
            <div class="flex-topcard-container">
              <div class="topcard-titles">OT Total</div>
              <div class="pill">${{ otTotal | digitFormatter }}</div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (heirarchyData && heirarchyData.length>0) {
  <div class=" uitk-l-grid__col--sm-12 uitk-l-grid__col--m-12 uitk-l-grid__col--lg-12">
    <div class="uitk-c-card uhc-font bottomCard">
      <div class="uitk-l-grid__col--12 stk-container-tabl-header">
        <div class="card-container">
          @for (l1 of filteredHeirarchyData ; track l1; let i = $index) {
          <mat-card class="leader-card">
            <table mat-table [dataSource]="[l1]" class="mat-elevation-z8 full-width-table">
              <!-- current Heirarchy -->
              <ng-container matColumnDef="currentHeirarchy">
                <th mat-header-cell *matHeaderCellDef [style.width.%]="25" class="current-hierarachy">
                  <div class="buttonAndHierFlex">
                    <button mat-icon-button class=" h-auto ml-2 expand-button" (click)="toggleExpanded(i)">
                      <mat-icon class="icon">
                        {{ expandedState[i] ? 'expand_more' : 'chevron_right' }}
                      </mat-icon>
                    </button>
                    <span class="current-header-text">
                      Current Hierarchy
                    </span>
                  </div>
                </th>
                <td mat-cell *matCellDef="let row">
                  <ul>
                    <li>
                      <span class="L1Leader">{{ row.Leader_L1_Name | uppercase }}</span>
                      @if (row.children?.length) {
                      <ul>
                        <ng-container
                          *ngTemplateOutlet="hierarchyTemplate; context: { data: row.children }"
                        ></ng-container>
                      </ul>
                      }
                    </li>
                  </ul>
                </td>
              </ng-container>
              <!-- Proposed Heirarchy -->
              <ng-container matColumnDef="activeHeirarchy">
                <th mat-header-cell [style.width.%]="35" *matHeaderCellDef>Proposed Hierarchy</th>
                <td mat-cell *matCellDef="let row; let rowIndex = index">
                  @if (editingRowIndex === i && tempActiveHierarchy !== null ) {
                  <ul class="prop-hierrachy">
                    @for (leader of tempActiveHierarchy; track leader; let i = $index) {
                    <li [style.marginLeft.px]="i * 20">
                      <div class="d-flex edit-button">
                        <span [class.first-lead]="i === 0">{{ leader | uppercase }}</span>
                        @if (i === tempActiveHierarchy.length -1) {
                        <span class="edit-screen-icon">
                          @if (!editMode[index]) {
                          <mat-icon (click)="toggleEdit(index)" class="icon icon-crud editPencil">edit</mat-icon>
                          } @if (editMode[index]) {
                          <mat-icon class="icon icon-crud cancel" (click)="toggleEdit(index)">cancel</mat-icon>
                          }
                        </span>
                        }
                      </div>
                    </li>
                    } @if (editMode[index]) {
                    <div class="pl-2 heirarchy-search">
                      <div class="table-search col-auto p-0 ">
                        <mat-form-field class="data-filter cd-table-search p-0" appearance="outline">
                          <input
                            [(ngModel)]="searchText"
                            matInput
                            type="text"
                            class="capability-search"
                            (keyup)="filterTree()"
                          />
                        </mat-form-field>
                      </div>
                      @if (!showHeirarchy ) {
                      <ul class="tree">
                        @for (node of filteredDataForSb; track node) {
                        <ng-container
                          *ngTemplateOutlet="renderNode; context: { $implicit: node, level: 1, index: index }"
                        ></ng-container>
                        }
                      </ul>
                      }
                    </div>
                    }
                  </ul>
                  } @else {
                  <ul>
                    <li>
                      <span class="leader-one">{{ row.Proposed_Leader_L1_Name | uppercase }}</span>
                      @if (row.children?.length) {
                      <ul>
                        <ng-container
                          *ngTemplateOutlet="
                            hierarchyTemplate;
                            context: { data: row.children, level: 2, isProposed: true, index: i }
                          "
                        ></ng-container>
                      </ul>
                      }
                    </li>
                  </ul>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="heirarchySegment">
                <th mat-header-cell *matHeaderCellDef [style.width.%]="20">Hierarchy Segment</th>
                <td mat-cell *matCellDef class="align-middle">
                  <span>{{ l1.HierarchySegmentee }}</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef class="text-center" [style.width.%]="20">Action</th>
                <td mat-cell *matCellDef="let row" class="align-middle text-center">
                  <ng-container>
                    <button
                      (click)="AddNewEntry(i, row)"
                      [disabled]="(!row.Proposed_Leader_L1_Name && !leaderSelected[i]) || !checkAccess(i)"
                      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs acceptAndApplyButton"
                    >
                      Accept and Apply
                    </button>
                  </ng-container>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns" class="outertable"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
            </table>

            @if (expandedState[i]) {
            <div class="leader-card-ucmg">
              <table mat-table [dataSource]="l1.ucmgs" class="mat-elevation-z8 ucmg-table">
                <ng-container matColumnDef="ucmg">
                  <th mat-header-cell *matHeaderCellDef class="ucmg-header">
                    <span class="ml-2 first">UCMG ID/NAME</span>
                  </th>
                  <td mat-cell *matCellDef="let ucmg">{{ ucmg.UCMG_ID }} - {{ ucmg.UCMG_Name }}</td>
                </ng-container>
                <ng-container matColumnDef="segment">
                  <th mat-header-cell *matHeaderCellDef>Segment</th>
                  <td mat-cell *matCellDef="let ucmg">{{ ucmg.segment }}</td>
                </ng-container>
                <ng-container matColumnDef="otLabour">
                  <th mat-header-cell *matHeaderCellDef>OT Labour</th>
                  <td mat-cell *matCellDef="let ucmg">
                    {{ ucmg.Optum_Tech_Labour | currency: 'USD':'symbol':'1.0-0' }}
                  </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsForExpand" class="table-head"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsForExpand"></tr>
              </table>
            </div>
            }
          </mat-card>
          }
        </div>
      </div>
    </div>
  </div>
  } @if (showLoader) {
  <div class="stk-table-loader segment-loader ">
    <app-loader> </app-loader>
  </div>
  }

  <!-- recursive tree template -->
  <ng-template #renderNode let-node let-level="level" let-index="index">
    <li class="override">
      <div
        class="node-content level-{{ level }} current-hierarachy-dropdown"
        [ngClass]="{ 'ps-4': node.children?.length == 0, 'ms-3': node.children?.length == 0 }"
      >
        @if (node.children?.length) {
        <button mat-icon-button (click)="toggleNode(node)" class="h-auto expand-button">
          <mat-icon>{{ isExpanded(getNodeId(node)) ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
        }
        <span class="circle m-0" [ngClass]="{ 'extra-margin': node.children?.length == 0 }">L{{ level }}</span>
        <span
          [innerHTML]="highlightText(getLeaderName(node))"
          (click)="onSelectNode(node, index)"
          [class.selected]="isSelected(node)"
        ></span>
      </div>
      @if (isExpanded(getNodeId(node))) {
      <ul>
        @for (child of node.children; track child) {
        <ng-container
          *ngTemplateOutlet="renderNode; context: { $implicit: child, level: level + 1, index: index }"
        ></ng-container>
        }
      </ul>
      }
    </li>
  </ng-template>

  <!-- recusive template for table -->

  <ng-template #hierarchyTemplate let-data="data" let-isProposed="isProposed" let-level="level" let-index="index">
    <ul>
      @for (node of data; track node; let i = $index) {
      <li [style.padding-left.px]="i * 20">
        <div class="d-flex edit-button">
          <span
            [innerHTML]="
              isProposed
                ? (node['Proposed_' + getLeaderLevel(node)] || '').toUpperCase()
                : (node[getLeaderLevel(node)] || '').toUpperCase()
            "
          >
          </span>
          @if (isProposed && node.children?.length === 0) {
          <span class="edit-screen-icon">
            @if (!editMode[index]) {
            <mat-icon
              (click)="toggleEdit(index)"
              class="icon icon-crud editPencil"
              [ngClass]="{ 'disable-icon': !checkAccess(i) }"
              >edit</mat-icon
            >
            } @if (editMode[index]) {
            <mat-icon class="icon icon-crud cancel" (click)="toggleEdit(index)">cancel</mat-icon>
            }
          </span>
          }
        </div>
        @if (isProposed && editMode[index] && node.children?.length === 0) {
        <div class="pl-2 heirarchy-search">
          <div class="table-search col-auto p-0 me-4">
            <mat-form-field class=" d-flex data-filter cd-table-search p-0" appearance="outline">
              <input [(ngModel)]="searchText" matInput type="text" class="capability-search" (keyup)="filterTree()" />
            </mat-form-field>
          </div>
          @if (!showHeirarchy) {
          <ul class="tree">
            @for (node of filteredDataForSb; track node) {
            <ng-container
              *ngTemplateOutlet="renderNode; context: { $implicit: node, level: 1, index: index }"
            ></ng-container>
            }
          </ul>
          }
        </div>
        } @if (node.children?.length) {
        <ul>
          <ng-container
            *ngTemplateOutlet="
              hierarchyTemplate;
              context: { data: node.children, isProposed: isProposed, index: index }
            "
          ></ng-container>
        </ul>
        }
      </li>
      }
    </ul>
  </ng-template>
</div>
